export enum EJccFormTypes {
    ADD_CARD,
    PAY_BALANCE,
}
